<div class="vc-modal__innerContainer">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>

  <div class="vc-modal__title" *ngIf="!error" i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODAL.SUCCESS_TITLE">
    This item was successfully added to your basket
  </div>

  <div class="vc-modal__content">
    <div class="addToCart">
      <div class="addToCart__content" *ngIf="!error">
        <div class="addToCart__content__product">
          <img
            class="addToCart__content__product__image"
            src="https://vestiairecollective.imgix.net/produit/{{
              product.pictures[0].path
            }}?w=100&auto=format&fm=pjpg&ch=DPR"
            alt="{{ product.pictures[0].alt }}"
          />

          <div class="addToCart__content__product__description">
            <div class="addToCart__content__product__title">
              <p class="addToCart__content__product__brand">{{ product.brand.name }}</p>
              <p class="addToCart__content__product__category">{{ product.category.localizedName }}</p>
            </div>
            <div class="addToCart__content__product__price">
              <p *ngIf="product.price.formatted">
                <span
                  class="price--strikeOut"
                  *ngIf="product?.regularPrice?.cents !== null && product?.regularPrice?.formatted !== '0'"
                  >{{ product.regularPrice.formatted }}</span
                >
                <span
                  [class.price--promo]="
                    product?.regularPrice?.cents !== null && product?.regularPrice?.formatted !== '0'
                  "
                  >{{ product.price.formatted }}</span
                >
                <span *ngIf="displayTaxes" class="price--ttc" i18n="@@PRODUCT.DETAILS.TTC">inc. tax</span>
              </p>
            </div>
          </div>
        </div>

        <div
          class="addToCart__content__premium"
          *ngIf="isReserved"
          i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODAL.ADD_TO_CART_PREMIUM"
        >
          This item is in your cart. It is reserved for {{ reservationExpirationDate | appDateInterval }} thanks to your
          Premium subscription.
        </div>
      </div>

      <div class="addToCart__content" *ngIf="error">
        <ng-container *ngIf="errorMessage">{{ errorMessage }}</ng-container>
        <ng-container *ngIf="!errorMessage" i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODAL.TECHNICAL_PROBLEM"
          >This item is already in your cart.</ng-container
        >
      </div>

      <div class="addToCart__actions">
        <button
          class="addToCart__actions__button addToCart__actions__button--checkout vc-btn vc-btn--primary vc-btn--full vc-btn--large vc-btn--notfull--md-up vc-btn--medium"
          i18n-routerLink="@@LINKS.SEE_MY_CART"
          routerLink="/shop-cart.shtml"
          i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODAL.SHOW_CART"
        >
          Proceed to Checkout
        </button>

        <button
          class="addToCart__actions__button addToCart__actions__button--shop vc-btn vc-btn--secondary vc-btn--full vc-btn--large vc-btn--notfull--md-up vc-btn--medium"
          (click)="closePopin()"
          i18n="@@PRODUCT.DESCRIPTION.DETAILS.MODAL.CONTINUE_SHOPPING"
        >
          Continue shopping
        </button>
      </div>
    </div>
  </div>
</div>
